"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detail_page = exports.RETURN_TO_LIST = exports.FOOTER = exports.BOX1TITLE = exports.BOX1TEXT = exports.FOOTERTITLE = exports.BOX2TITLE = exports.BOX2TEXT = exports.BOX3TITLE = exports.BOX3TEXT = exports.BOX4TITLE = exports.BOX4TEXT = exports.TEXTLINK = exports.LINK = exports.SHARE = exports.DETAIL_PAGE = exports.INTRO2 = exports.INTRO = exports.DESCRIPTION2 = exports.DESCRIPTION = exports.TITLE = exports.FONT_COLOR = exports.LINK_COLOR = exports.SUBTITLE = exports.URL = exports.SRHE_TEXT = exports.SRHE_LINK = exports.SUBSCRIBE_TEXT = exports.SUBSCRIBE_LINK = exports.TIMES = exports.LOCATIONS = exports.IFRAME_URL = exports.API_URL_IES = exports.API_URL_AEF = exports.Resultslist = void 0;
// Importation des modules nécessaires
const etic_1 = require("./services/etic");
require("./styles/styles.scss");
require("./styles/filter.scss");
const resultsListAEF_1 = require("./components/resultsListAEF");
const resultsListIES_1 = require("./components/resultsListIES");
/**
 * Job array
 */
exports.Resultslist = [];
var domains = new Map();
var times = new Map();
var locations = new Map();
var data;
var JobImage;
var origin;
exports.API_URL_AEF = window.env?.API_URL_AEF || '';
exports.API_URL_IES = window.env?.API_URL_IES || '';
exports.IFRAME_URL = window.env?.IFRAME_URL || '';
exports.LOCATIONS = window.env?.LOCATIONS || 'Tout le canton,Montagnes,Val-de-Ruz,Val-de-Travers,Littoral';
exports.TIMES = window.env?.TIMES || '80 % - 100 %,50 % - 75 %,Moins de 50 %';
exports.SUBSCRIBE_LINK = window.env?.SUBSCRIBE_LINK || '';
exports.SUBSCRIBE_TEXT = window.env?.SUBSCRIBE_TEXT || '';
exports.SRHE_LINK = window.env?.SRHE_LINK || '';
exports.SRHE_TEXT = window.env?.SRHE_TEXT || '';
exports.URL = window.env?.URL || '';
exports.SUBTITLE = window.env?.SUBTITLE || '';
exports.LINK_COLOR = window.env?.LINK_COLOR || '#009776';
exports.FONT_COLOR = window.env?.FONT_COLOR || '#292929';
exports.TITLE = window.env?.TITLE || '';
exports.DESCRIPTION = window.env?.DESCRIPTION || '';
exports.DESCRIPTION2 = window.env?.DESCRIPTION2 || '';
exports.INTRO = window.env?.INTRO || '';
exports.INTRO2 = window.env?.INTRO2 || '';
exports.DETAIL_PAGE = window.env?.DETAIL_PAGE || '';
exports.SHARE = window.env?.SHARE || false;
exports.LINK = window.env?.LINK || '';
exports.TEXTLINK = window.env?.TEXTLINK || '';
exports.BOX4TEXT = window.env?.BOX4TEXT || '';
exports.BOX4TITLE = window.env?.BOX4TITLE || '';
exports.BOX3TEXT = window.env?.BOX3TEXT || '';
exports.BOX3TITLE = window.env?.BOX3TITLE || '';
exports.BOX2TEXT = window.env?.BOX2TEXT || '';
exports.BOX2TITLE = window.env?.BOX2TITLE || '';
exports.FOOTERTITLE = window.env?.FOOTERTITLE || '';
exports.BOX1TEXT = window.env?.BOX1TEXT || '';
exports.BOX1TITLE = window.env?.BOX1TITLE || '';
exports.FOOTER = window.env?.FOOTER || '';
exports.RETURN_TO_LIST = window.env?.RETURN_TO_LIST || '';
exports.detail_page = false;
async function initializeApp() {
    try {
        let app = document.getElementById('app');
        app.innerHTML = `<div class="loader" style="margin-top:50px;border-top: 10px solid ${exports.LINK_COLOR};" title="Chargement..."></div>`;
        renderList();
        //console.log(Resultslist);
        handleHashChange();
        window.addEventListener("popstate", handleHashChange);
    }
    catch (error) {
        console.error("Erreur lors de l'initialisation de l'application", error);
    }
    console.log("Application initialisée");
}
function renderDetail(id) {
    let job;
    exports.Resultslist.forEach(element => {
        if (id === Number(element.StellenID)) {
            job = element;
        }
    });
    handleBackToList();
    document.body.scrollIntoView({ behavior: "instant" });
}
function renderList() {
    try {
        let path = window.location.pathname.slice(1);
        let href = window.location.href;
        if (path == 'extrafamilliale' || href == 'https://calculette-aef.ne.ch/') {
            (0, resultsListAEF_1.displayExtra)(exports.Resultslist);
            handleSubmitAEF();
        }
        else {
            (0, resultsListIES_1.displayIES)(exports.Resultslist);
            handleSubmitIES();
        }
    }
    catch (error) {
        let app = document.getElementById('app');
        app.innerHTML = `
            <p> Aucun élément à afficher. </p>
        `;
    }
}
document.addEventListener("DOMContentLoaded", initializeApp);
function handleBackToList() {
    document.getElementById('back')?.addEventListener('click', (e) => {
        e.preventDefault();
        window.history.pushState('', "Liste", '/');
        renderList();
        exports.detail_page = false;
    });
}
function handleSubmitAEF() {
    document.getElementById('revenu')?.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            submitAEF();
        }
    });
    document.getElementById('submit')?.addEventListener('click', async (e) => {
        e.preventDefault();
        submitAEF();
    });
}
async function submitAEF() {
    const revenu = document.getElementById('revenu').value;
    await etic_1.SpajService.getData(exports.API_URL_AEF, revenu);
    exports.Resultslist = etic_1.SpajService.resultsList;
    renderList();
    exports.detail_page = false;
}
function handleSubmitIES() {
    document.getElementById('revenu')?.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            submitIES();
        }
    });
    document.getElementById('submit')?.addEventListener('click', async (e) => {
        e.preventDefault();
        submitIES();
    });
}
async function submitIES() {
    const revenu = document.getElementById('revenu').value;
    const status = document.getElementById('status').value;
    const nb = document.getElementById('nb').value;
    await etic_1.IESService.getData(exports.API_URL_IES, status, nb, revenu);
    exports.Resultslist = etic_1.IESService.resultsList;
    renderList();
}
function menuListener() {
    let items = document.querySelectorAll('.menu-item a');
    Array.from(items).forEach(e => {
        e.addEventListener('click', function (e) {
            e.preventDefault();
            handleMenu(e.currentTarget.pathname);
        });
    });
}
function handleMenu(e = null) {
    window.history.pushState('', "list" + e, e);
    var popStateEvent = new PopStateEvent('popstate');
    dispatchEvent(popStateEvent);
}
function handleHashChange(e = null) {
    if (e)
        e.preventDefault();
    renderList();
    menuListener();
}
